import type { HekateDisplayForm } from '@onshape/www-inertia';
import ServiceEndpointsUtil from '../../../util/ServiceEndpointsUtil';
import type { FormSubmitResolution } from '../../../../model/HekateFormSubmission';
import AntiSpamUtil from '../../../util/AntiSpamUtil';
import type { ButtonPortableText } from '~/sanity/types';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class FormSubmitResolutionProvider {
  public static async resolve({
    formDefinition,
    successMessagePortableText,
  }: {
    formDefinition: Ref<HekateDisplayForm | null>;
    successMessagePortableText: Ref<ButtonPortableText | undefined>;
  }): Promise<FormSubmitResolution | null> {
    if (!formDefinition.value) return null;

    const data: { [key: string]: string | boolean | number } = {};
    formDefinition.value.displayFields.forEach((field) => {
      if (field.dataType === 'none') {
        return;
      }
      data[field.htmlName] = field.val;
    });

    const body = JSON.stringify({
      ...data,
    });

    const nounce = Math.round(Math.random() * (1 << 30)).toString(16);
    const url = `${ServiceEndpointsUtil.submitFormResolutionEndpoint}?nounce=${nounce}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(await AntiSpamUtil.commonFetchHeaders()),
      },
      body,
    });
    const json = await response.json();

    return {
      formId: formDefinition.value.id,
      successActions: json.successActions,
      successMessagePortableText,
    };
  }
}
